import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import index from '@/view/index'
import exhibition from '@/view/exhibition'
import preview from '@/view/preview'
import exhibitionItem from '@/view/exhibitionItem'
import booking from '@/view/booking'
import ActivityConsultation from '@/view/ActivityConsultation'
import services from '@/view/services'
import details from '@/view/details'//activeDetail
import activeDetail from '@/view/activeDetail'
import activeDetails from '@/view/activeDetails'
import login from '@/view/login'
import teram from '@/view/teram'
import assets from '@/components/assets'
import enter from '@/components/enter'
import enters from '@/view/enters'
Vue.use(Router)
// ActivityConsultation
export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/exhibition',
      name: 'exhibition',
      component: exhibition
    },
    {
      path: '/preview',
      name: 'preview',
      component: preview
    },
    {
      path: '/exhibitionItem',
      name: 'exhibitionItem',
      component: exhibitionItem
    },
    {
      path: '/booking',
      name: 'booking',
      component: booking
    },
    {
      path: '/ActivityConsultation',
      name: 'ActivityConsultation',
      component: ActivityConsultation
    },
    {
      path: '/services',
      name: 'services',
      component:services
    },
    {
      path: '/details',
      name: 'details',
      component:details
    },
    {
      path: '/activeDetail',
      name: 'activeDetail',
      component:activeDetail
    },
    {
      path: '/activeDetails',
      name: 'activeDetails',
      component:activeDetails
    },
    {
      path:'/teram',
      name:'teram',
      component:teram
    },
    {
      path:'/login',
      name:'login',
      component:login
    },
    {
      path:'/assets',
      name:'assets',
      component:assets
    },
    {
      path:'/enter',
      name:'enter',
      component:enter
    },
    {
      path:'/enters',
      name:'enters',
      component:enters
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js